
import { defineComponent, reactive, watch } from 'vue'

export default defineComponent({
  name: 'InputTime',
  emits: ['update:modelValue'],
  props: {
    modelValue: Number // seconds
  },
  setup(props, { emit }) {   

    const d = new Date((props.modelValue || 0) * 60 * 1000)

    const state = reactive({
      hours: d.getHours() - 1,
      minutes: d.getMinutes(),
      seconds: d.getSeconds()
    })

    watch(() => state, (newTime) => {
      emit('update:modelValue', newTime)
    })

    return { state }
  }
})
